//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'seckillGood',

  data() {
    return {
      sdate:"",
      countDownDay: "00",
      countDownHour:"00",
      countDownMinute:"00",
      countDownSecond:"00"
    }
  },
  computed: {

  },
  props: {
    goodInfo: {
      type: Object,
      value: null,
    },
    minLadderPrice: {
      type: Object,
      value: null,
    },
    goods: {
      type: Object,
      value: null,
    },
    isCycle:{
      type: Boolean,
      value: false,
    },
    staticDomain:{
      type: String,
      value: false,
    }
  },
  methods: {
    splitFun: function(str, sign, num) {
      if (str != undefined) {
        str = str.toString();
        let arr = str.split(sign);
        if (arr.length > num) {
          return arr[num];
        } else {
          return "00";
        }
      }
      return "";
    },
    strLengthFun: function(str) {
      if (str != undefined) {
        let num = str.length;
        return num;
      }
      return 0;
    },
    //限时直降剩余时间
    getNewTime: function(s) {
      if (s > -1) {
        var day = Math.floor(s / 86400);
        var hour = Math.floor(s / 3600) % 24;
        var min = Math.floor(s / 60) % 60;
        var sec = s % 60;

        if (day < 10) {
          day = '0' + day;
        }
        if (hour < 10) {
          hour = '0' + hour;
        }
        if (min < 10) {
          min = '0' + min;
        }
        if (sec < 10) {
          sec = '0' + sec;
        }
      }

      this.countDownDay = day;
      this.countDownHour = hour;
      this.countDownMinute = min;
      this.countDownSecond = sec;

      let that = this;

      setTimeout(function(){
        that.sdate = s - 1;
        that.getNewTime(that.sdate)
      },1000)
    },

  },
  created() {
    console.log("11111111111111",this.minLadderPrice)
    //限时直降时间
    this.sdate = this.goodInfo.sdate;
    this.getNewTime(this.sdate)
  }
}



// WEBPACK FOOTER //
// ./src/components/goodDetail/seckillGood.vue